import { useDispatch, useSelector } from "react-redux";

import type { ThunkDispatchCommon } from "single-spa/store/types";

import { CONTACTS_SEARCH_TABLE_INITIAL_PAGE } from "../../constants/table";
import trackingService from "../../services/tracking/trackingService";
import { actionsPanelFiltersChangedAction, tableFiltersChangedAction } from "../../store/action-creators";
import { selectContactsSearchText, selectIsOnlyRevealedShown } from "../../store/selectors";

import ContactsSearchTextBox from "./ContactsSearchTextBox";

interface IProps {
    isDisabled?: boolean;
}

const ContactsSearchTextBoxContainer = ({ isDisabled }: IProps) => {
    const dispatch: ThunkDispatchCommon = useDispatch();
    const searchText: string = useSelector(selectContactsSearchText);
    const isOnlyRevealedShown: boolean = useSelector(selectIsOnlyRevealedShown);

    const handleSearch = (searchText: string) => {
        dispatch(tableFiltersChangedAction({ searchText, page: CONTACTS_SEARCH_TABLE_INITIAL_PAGE }));
    };

    const handleRevealedOnlyToggle = (isSelected: boolean) => {
        trackingService.trackRevealedContactsOnlyToggle(isSelected);

        dispatch(
            actionsPanelFiltersChangedAction({
                includeOnlyRevealed: isSelected,
                page: CONTACTS_SEARCH_TABLE_INITIAL_PAGE,
            }),
        );
    };

    return (
        <ContactsSearchTextBox
            searchText={searchText}
            isOnlyRevealed={isOnlyRevealedShown}
            isDisabled={isDisabled}
            onSearch={handleSearch}
            onRevealedToggle={handleRevealedOnlyToggle}
        />
    );
};

export default ContactsSearchTextBoxContainer;
